import type { LayerPattern } from '../patterns/index';
import { LAYER_SETTINGS_TYPES } from '../constants';

export const userCircle: LayerPattern = {
    id: 'UserCircle',
    key: 'user_circles',
    title: 'Окружность',
    hide: true,
    settings: [
        {
            title: 'Точки пересечения окружностей ',
            key: 'intersectionTextVisible',
            type: LAYER_SETTINGS_TYPES.BOOLEAN,
            defaultValue: true,
            level: 0,
        },
        {
            title: 'Видимость текста',
            key: 'userCircleTextVisible',
            type: LAYER_SETTINGS_TYPES.BOOLEAN,
            defaultValue: true,
            level: 0,
        },
    ],
};
